module.exports = __webpack_public_path__ + "img/smallrentou_sample.3fadb2c5.png";